import React, { useEffect, useRef, useState } from "react";
import styles from "./ClipText.module.scss";
import cx from "classnames";

interface Props {
  className?: string | { [key: string]: string };
  fixedRows?: boolean;
  rows?: number;
  heightRatio?: number;
  children?: any;
}

const calcHeight = (
  lineHeight: string,
  rows: number,
  heightRatio: number
): string => {
  const [lnHeight, lnHeightUnit] = lineHeight.split(/(\d+)/).filter(Boolean);
  let unit = "px";
  const defaultHeight = `${rows * heightRatio}em`;
  if (!!lnHeightUnit) {
    unit = lnHeightUnit;
  }
  if (Number.isNaN(parseInt(lnHeight))) {
    return defaultHeight;
  } else {
    if (["px", "rem", "em"].includes(unit)) {
      return `${rows * parseInt(lnHeight)}${unit}`;
    } else {
      return defaultHeight;
    }
  }
};
const defaultLineHeight = "1.5em";
export default function ClipText({
  rows = 2,
  heightRatio = 1.5,
  children,
  fixedRows = false,
  className,
}: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [lineHeight, setLineHeight] = useState(defaultLineHeight);
  useEffect(() => {
    const lineHeightProp = "line-height";
    setLineHeight(
      document?.defaultView
        ?.getComputedStyle?.(ref.current as Element, null)
        ?.getPropertyValue?.(lineHeightProp) ?? defaultLineHeight
    );
  }, [ref.current?.clientHeight]);

  return (
    <div
      ref={ref}
      className={cx(styles.clipText, className)}
      style={{
        WebkitLineClamp: rows,
        height: fixedRows
          ? calcHeight(lineHeight, rows, heightRatio)
          : undefined,
      }}
    >
      {children}
    </div>
  );
}
